export type StepPreparer = (target: HTMLElement) => Promise<void>;
export type AnchorRevealer = () => Promise<void> | void;

const preparers = new Map<string, StepPreparer>();
const revealers = new Map<string, AnchorRevealer>();

export const registerStepPreparer = (anchor: string, preparer: StepPreparer): (() => void) => {
  preparers.set(anchor, preparer);
  return () => {
    if (preparers.get(anchor) === preparer) {
      preparers.delete(anchor);
    }
  };
};

export const getStepPreparer = (anchor: string): StepPreparer | undefined => preparers.get(anchor);

export const registerAnchorRevealer = (anchor: string, revealer: AnchorRevealer): (() => void) => {
  revealers.set(anchor, revealer);
  return () => {
    if (revealers.get(anchor) === revealer) {
      revealers.delete(anchor);
    }
  };
};

export const getAnchorRevealer = (anchor: string): AnchorRevealer | undefined =>
  revealers.get(anchor);
